import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import {
  makeBillDetail,
  makeBillDetailDataByName,
} from '../../redux/selectors/billDetail';
import { getCurrentSubmitBillDataByName } from '../../redux/selectors/transactionDetail';
import getTotalExtra from '../../utils/getTotalExtra';
import { BillDetailSection } from '../OrderDetailSections';

const mapStateToProps = (_initialOwnState, initialOwnProps) => {
  const page = initialOwnProps.page;
  const extraDetail = getTotalExtra(page);
  const selector = createStructuredSelector({
    details: makeBillDetail(extraDetail),
    totalPriceTW: makeBillDetailDataByName('total_price_tw'),
    selectedMethod: getCurrentSubmitBillDataByName('delivery_mode'),
  });

  return state => selector(state);
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(BillDetailSection);
